import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import { API_BASE_URL } from '@config';

export const SET_TRAINING_RECORDINGS = 'SET_TRAINING_RECORDINGS';
export const SET_TRAINING_RECORDINGS_LOADING = 'SET_TRAINING_RECORDINGS_LOADING';
export const SET_TRAINING_RECORDINGS_ERROR = 'SET_TRAINING_RECORDINGS_ERROR';
export const PATCH_TRAINING_RECORDING = 'PATCH_TRAINING_RECORDING';
export const REMOVE_TRAINING_RECORDING = 'REMOVE_TRAINING_RECORDING';

export const setTrainingRecordings = (data) => ({ type: SET_TRAINING_RECORDINGS, payload: data });
export const setTrainingRecordingsLoading = (v) => ({ type: SET_TRAINING_RECORDINGS_LOADING, payload: v });
export const setTrainingRecordingsError = (e) => ({ type: SET_TRAINING_RECORDINGS_ERROR, payload: e });
export const patchTrainingRecordingLocal = (rec) => ({ type: PATCH_TRAINING_RECORDING, payload: rec });
export const removeTrainingRecordingLocal = (id) => ({ type: REMOVE_TRAINING_RECORDING, payload: id });

export const getTrainingRecordings = (trainingId) => (dispatch) => {
  if (!trainingId) return Promise.resolve({ recordings: [] });
  dispatch(setTrainingRecordingsLoading(true));
  return axios
    .get(`${API_BASE_URL}/api/recordings/trainings/${encodeURIComponent(trainingId)}`)
    .then((response) => {
      const recs = (response.data && response.data.recordings) || [];
      dispatch(setTrainingRecordings({ trainingId, recordings: recs }));
      dispatch(setTrainingRecordingsLoading(false));
      return response.data;
    })
    .catch((err) => {
      dispatch(setTrainingRecordingsLoading(false));
      const msg = err.response?.data?.message || err.response?.data?.error || 'Failed to load recordings';
      dispatch(setTrainingRecordingsError(msg));
      throw err;
    });
};

export const getClusterRecordings = (clusterId) => (dispatch) => {
  if (!clusterId) return Promise.resolve({ recordings: [] });
  dispatch(setTrainingRecordingsLoading(true));
  return axios
    .get(`${API_BASE_URL}/api/recordings/clusters/${encodeURIComponent(clusterId)}`)
    .then((response) => {
      const recs = (response.data && response.data.recordings) || [];
      dispatch(setTrainingRecordings({ trainingId: null, clusterId, recordings: recs }));
      dispatch(setTrainingRecordingsLoading(false));
      return response.data;
    })
    .catch((err) => {
      dispatch(setTrainingRecordingsLoading(false));
      const msg = err.response?.data?.message || err.response?.data?.error || 'Failed to load recordings';
      dispatch(setTrainingRecordingsError(msg));
      throw err;
    });
};

export const updateTrainingRecording = (id, patch) => (dispatch) => {
  return axios
    .patch(`${API_BASE_URL}/api/recordings/${encodeURIComponent(id)}`, patch)
    .then((response) => {
      dispatch(patchTrainingRecordingLocal(response.data));
      dispatch(showMessage({ message: 'Recording updated' }));
      return response.data;
    })
    .catch((err) => {
      const msg = err.response?.data?.message || err.response?.data?.error || 'Update failed';
      dispatch(showMessage({ message: msg, variant: 'error' }));
      throw err;
    });
};

export const deleteTrainingRecording = (id) => (dispatch) => {
  return axios
    .delete(`${API_BASE_URL}/api/recordings/${encodeURIComponent(id)}`)
    .then(() => {
      dispatch(removeTrainingRecordingLocal(id));
      dispatch(showMessage({ message: 'Recording deleted' }));
    })
    .catch((err) => {
      const msg = err.response?.data?.message || err.response?.data?.error || 'Delete failed';
      dispatch(showMessage({ message: msg, variant: 'error' }));
      throw err;
    });
};

// Owner-initiated "Share with professor". Idempotent on the server, so
// we don't pre-check the current state - just POST and reconcile the
// returned DTO into the recordings list.
export const shareTrainingRecording = (id) => (dispatch) => {
  return axios
    .post(`${API_BASE_URL}/api/recordings/${encodeURIComponent(id)}/share`)
    .then((response) => {
      dispatch(patchTrainingRecordingLocal(response.data));
      dispatch(showMessage({ message: 'Recording shared with instructor' }));
      return response.data;
    })
    .catch((err) => {
      const msg = err.response?.data?.message || err.response?.data?.error || 'Share failed';
      dispatch(showMessage({ message: msg, variant: 'error' }));
      throw err;
    });
};

export const unshareTrainingRecording = (id) => (dispatch) => {
  return axios
    .post(`${API_BASE_URL}/api/recordings/${encodeURIComponent(id)}/unshare`)
    .then((response) => {
      dispatch(patchTrainingRecordingLocal(response.data));
      dispatch(showMessage({ message: 'Recording is private again' }));
      return response.data;
    })
    .catch((err) => {
      const msg = err.response?.data?.message || err.response?.data?.error || 'Unshare failed';
      dispatch(showMessage({ message: msg, variant: 'error' }));
      throw err;
    });
};
